<template>
  <div class="collect">
    <!-- 案例征集 已用外部链接代替 -->
    <iframe :src="csrc" frameborder="0"></iframe>
  </div>
</template>

<script>
/* eslint-disable keyword-spacing */
export default {
  name: 'Collect',
  data () {
    return {
      params: '',
      sid: '',
      csrc: ''
    }
  },
  created () {
    this.params = this.$route.query
    this.sid = this.params.sid
    this.setSid()
  },
  methods: {
    setSid () {
    // if(this.sid!=this.global.area_id){
    //   this.sid = this.global.area_id;
    // }
      let s = (this.sid).toString()
      switch(s) {
        case '2691':
          this.csrc = 'http://p.msup.cn/xtRU'
          break
        case '2690':
          this.csrc = 'http://p.msup.cn/yEVX'
          break
        default:
          break
      }
    }
  }
}
</script>

<style scoped>
.collect {
  background: #eee;
}
iframe {
  width: 100%;
  height: 2200px;
  margin-top: 140px;
}
@media (max-width:767px) {
  iframe {
    height: 2200px;
    margin-top: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Collect.vue